import { useRouter } from "next/router";
import { useMemo } from "react";
import { numberCheck } from "@common/NumberCheck";

// hash 형식: P + 16자리 숫자
const isValidHash = (val) => /^P\d{16}$/.test(val);

export const useProductPageType = () => {
  const router = useRouter();

  const lastSlug = useMemo(() => {
    if (!router.isReady) return null;
    const pathSegments = router.asPath.split("/").filter(Boolean);
    return pathSegments[pathSegments.length - 1];
  }, [router.asPath, router.isReady]);

  const isDetailPage = useMemo(() => {
    if (!lastSlug || !lastSlug.startsWith("P")) return false;
    const numberPart = lastSlug.slice(1);
    return numberCheck(numberPart); // 숫자인지 확인
  }, [lastSlug]);

  return { isDetailPage, lastSlug };
};

export const useProductDetailPageType = () => {
  const { isReady, query } = useRouter();
  const hash = query.hash;

  const isDetailPage = useMemo(() => {
    if (!isReady || typeof hash !== "string") return false;
    return isValidHash(hash);
  }, [isReady, hash]);

  return { isDetailPage, lastSlug: hash };
};
